import 'arrive';

// Import Swiper bundle (include tutti i moduli)
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.arrive('.block-spotlight', { existing: true }, function () {
    const recentlyPublishedSwiper = new Swiper('.block-spotlight__slider .swiper', {
        slidesPerView: 1.2,
        spaceBetween: 8,
        centeredSlides: false,
        loop: true,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: 'auto',
        },
        breakpoints: {
            767: {
                slidesPerView: 2,
                spaceBetween: 24,
            }
        }
    });
});
